import { render, staticRenderFns } from "./PreviewTemplateFields.vue?vue&type=template&id=39b53e58&scoped=true"
import script from "./PreviewTemplateFields.vue?vue&type=script&lang=js"
export * from "./PreviewTemplateFields.vue?vue&type=script&lang=js"
import style0 from "./PreviewTemplateFields.vue?vue&type=style&index=0&id=39b53e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b53e58",
  null
  
)

export default component.exports